import { FilterDateDashboard } from "../../../../components/Dashboard/ViewDatas/FilterDate";
import { ReactComponent as BagFood } from "../../../../assets/svg/icons/bagFood.svg";
import { DateModal } from "../../../../components/Modal/DateFilter";
import { useFilter } from "../../../../hooks/useFilter";
import Constants from "../../../../constants/Index";
import { useEffect, useRef, useState } from "react";
import { Dropdown } from "../../../../components/EditOnboarding/components/Select";
import { useForm } from "react-hook-form";
import { format } from "date-fns";
import ChartBar from "../../../../components/Graph/Bar";
import ChartBarLine from "../../../../components/Graph/BarLine";
import mockLotacaoPasto from "../../../../mocks/managementGeneralMicroArea.json"
import { IOptionDoubleValuesProps, IOptionProps, IOptionsProps } from "../../../../@types/reactSelect/IOption";
import axios from "../../../../services/axios";
import { LeafletStaticMap } from "../../../../components/Leaflet/LeafletStaticMap/Index";
import { FlyToBounds, FlyToBoundsRefProps } from "../../../../components/Leaflet/FlyToBounds/Index";
import { Polygon } from "react-leaflet";

export default function DashboardManagementMicroArea() {
    const {
        areasIdsFilter,
        rangeDays,
        setRangeDays,
        setHideMicroAreaFilter,
        setHideBatchFilter,
        setDashboard,
        setSideBarOptionSelected,
        setSelectRangeDate,
        snapshotMicroAreaMetrics,
        setSnapshotMicroAreaMetrics,
        farmFilter
    } = useFilter();

    const {
        handleSubmit,
        watch,
        control,
        setValue
    } = useForm();

    const [optionsTypeManagement, setOptionsTypeManagement] = useState<IOptionsProps>([]);
    const [lotInstConsumo, setLotInstConsumo] = useState<IOptionDoubleValuesProps>();
    const [lotInstAltura, setLotInstAltura] = useState<IOptionDoubleValuesProps>();
    const [managementOptions, setManagementOptions] = useState<IOptionsProps>();
    const [lotInstNota, setLotInstNota] = useState<IOptionDoubleValuesProps>();
    const [lotInst, setLotInst] = useState<IOptionsProps>([]);
    const [areas, setAreas] = useState<IArea[]>();
    const [microAreas, setMicroAreas] = useState<IMicroArea[]>();
    const [microAreasSelected, setMicroAreasSelected] = useState<Number[]>();

    const typeManagement = watch("managementType")
    const groupManagement = watch("managementGroup")

    useEffect(() => {
        setHideMicroAreaFilter(true)
        setHideBatchFilter(true)
        setSideBarOptionSelected("DASHBOARD")
        setDashboard("MANAGEMENT_PASTURE")
        setSelectRangeDate(0)
        document.title = Constants.TITLE_DASHBOARD;

        axios
            .get("/micro-area-management/types")
            .then((response) => {
                const types: IOptionsProps = response.data.map((type: any) => ({
                    label: type.name,
                    value: type.id,
                    info: type.monitoring_types
                }))
                setOptionsTypeManagement(types.filter((type: any) => type.value != 1))
            })

        const now = new Date();
        const firstDayOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const firstDayOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);

        setRangeDays({
            from: firstDayOfLastMonth,
            to: firstDayOfCurrentMonth
        })

        axios.get("/micro-areas").then(response => setMicroAreas(response.data))
    }, []);

    useEffect(() => {
        if (farmFilter) {
            axios.get(`/areas?farm_id=${farmFilter.id}`).then(response => setAreas(response.data))
        }
    }, [farmFilter]);

    useEffect(() => {
        if (farmFilter?.id && rangeDays && areas) {
            let startDate = format(rangeDays?.from ? new Date(rangeDays?.from) : new Date(), 'yyyy-MM-dd')
            let endDate = format(rangeDays?.to ? new Date(rangeDays?.to) : new Date(), 'yyyy-MM-dd')
            const defaultAreas = areas.map(area => area.id)

            axios.get(`/analytics/snapshots/management-groups?startDate=${startDate}&endDate=${endDate}&farmId=${farmFilter?.id}&${areasIdsFilter.length > 0 ? areasIdsFilter.map(area => `areaIds=${area.value}`).join("&") : defaultAreas.map(area => `areaIds=${area}`).join("&")}`)
                .then(response => setManagementOptions(response.data.map((option: IAnalyticsManagementGroups) => ({
                    label: `${option.management_type.name} - ${option.management_type.monitoring_types.map(el => el.name).join(",")}`,
                    value: option.management_group_id,
                    info: option
                }))))
        }
    }, [farmFilter, rangeDays, areas, areasIdsFilter]);

    useEffect(() => {
        if (rangeDays && areas) {
            let startDate = format(rangeDays?.from ? new Date(rangeDays?.from) : new Date(), 'yyyy-MM-dd')
            let endDate = format(rangeDays?.to ? new Date(rangeDays?.to) : new Date(), 'yyyy-MM-dd')

            if (groupManagement) {
                const microAreas = groupManagement.map((management: IOptionProps) => (management.info as IAnalyticsManagementGroups).micro_areas.map(microArea => microArea.id)).flat()

                axios.get(`/analytics/snapshots/micro-areas/metrics?startDate=${startDate}&endDate=${endDate}&${microAreas.length > 0 ? microAreas.map((microArea: number) => `areaIds=${microArea}`).join("&") : ""}`)
                    .then((response) => {
                        setSnapshotMicroAreaMetrics(response.data)
                    })
            }
        }
    }, [rangeDays, groupManagement]);

    useEffect(() => {
        if (snapshotMicroAreaMetrics) {
            setLotInstConsumo({
                data1: snapshotMicroAreaMetrics.daily_metrics.map(inst => ({
                    label: inst.date,
                    value: inst.total_consumption_kg
                })),
                data2: snapshotMicroAreaMetrics.daily_metrics.map(inst => ({
                    label: inst.date,
                    value: inst.average_instant_capacity_rate
                }))
            })
            setLotInstAltura({
                data1: snapshotMicroAreaMetrics.daily_metrics.map(inst => ({
                    label: inst.date,
                    value: inst.monitoring_counts.height_count
                })),
                data2: snapshotMicroAreaMetrics.daily_metrics.map(inst => ({
                    label: inst.date,
                    value: inst.average_instant_capacity_rate
                }))
            })
            setLotInstNota({
                data1: snapshotMicroAreaMetrics.daily_metrics.map(inst => ({
                    label: inst.date,
                    value: inst.monitoring_counts.rating_count
                })),
                data2: snapshotMicroAreaMetrics.daily_metrics.map(inst => ({
                    label: inst.date,
                    value: inst.average_instant_capacity_rate
                }))
            })
            setLotInst(snapshotMicroAreaMetrics.daily_metrics.map((inst) => ({
                label: inst.date,
                value: inst.average_instant_capacity_rate
            })))
        }
    }, [snapshotMicroAreaMetrics]);

    const OptionManagements = (option: any) => {
        const infoOption: IAnalyticsManagementGroups = option.data.info;
        const selectedValues = watch("managementGroup") || []

        function onSelect(option: any) {
            setValue("managementGroup", [...selectedValues, option.data])
        }

        return <div
            className="customDropdownOptions"
            style={{
                color: option.isSelected ? "#4D4D4D" : "#999999",
            }}
            onClick={() => onSelect(option)}
        >
            {infoOption.management_type.name} - {infoOption.management_type.monitoring_types.map(el => el.name).join(",")}
            <br />
            {infoOption.micro_areas.length > 0 ? infoOption.micro_areas.map(microArea => microArea.initials).join(" ") : ""}
        </div>
    }

    const flytoBoundsRef = useRef<FlyToBoundsRefProps>();

    useEffect(() => {
        if (groupManagement && groupManagement.length > 0) setMicroAreasSelected(groupManagement.map((management: IOptionProps) => (management.info as IAnalyticsManagementGroups).micro_areas.map(microArea => microArea.id)).flat())
    }, [groupManagement]);

    return (
        <div className="cattleMap_background" style={{ overflowY: "auto" }}>
            <form onSubmit={() => handleSubmit(() => { })} className="dashboardPastureManagement">

                <DateModal />

                <div className="cattleMap_page">
                    <div className="cattleMap_header">
                        <BagFood height={72} />
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                        }}>
                            <h2 className="cattleMap_title">
                                Manejo de Pasto
                            </h2>
                            <h3 className="cattleMap_subtitle">
                                Visualização por Pasto
                            </h3>
                        </div>
                    </div>

                    <div>
                        <FilterDateDashboard />
                        <div style={{ width: 400 }}>
                            <Dropdown
                                control={control}
                                label={"Tipo de pastejo"}
                                name={"managementType"}
                                placeholderText={"Selecione..."}
                                noOptionsMessage={() => "Nenhuma opção disponível"}
                                options={optionsTypeManagement}
                                isMulti
                            />

                            <Dropdown
                                control={control}
                                label={"Grupo de manejo"}
                                name={"managementGroup"}
                                placeholderText={"Selecione..."}
                                noOptionsMessage={() => "Nenhuma opção disponível"}
                                options={typeManagement ? managementOptions?.filter(option => Array.from(typeManagement.map(((type: IOptionProps) => type.value))).includes(`${option.info.management_type.id}`)) : []}
                                CustomOption={OptionManagements}
                                isMulti
                            />

                            {farmFilter && <div className="mapFilterManagement">
                                <LeafletStaticMap>
                                    <FlyToBounds ref={flytoBoundsRef} fitCoords={farmFilter.coords}>
                                        <Polygon
                                            dashArray={Constants.LEAFLET_DASHED_GREEN.dashArray}
                                            color={Constants.LEAFLET_DASHED_GREEN.color}
                                            fill={false}
                                            positions={farmFilter.coords}
                                        />
                                        {/* microArea */}
                                        {microAreas?.filter(microarea => microAreasSelected?.includes(microarea.id))?.map(microarea => <Polygon
                                            positions={microarea.map_coords!}
                                            color={Constants.LEAFLET_UNFOCUS_TRANSLUCENT.color}
                                            fillColor={Constants.LEAFLET_NORMAL_BLUE.fillColor}
                                            fillOpacity={
                                                Constants.LEAFLET_UNFOCUS_TRANSLUCENT.fillOpacity
                                            }
                                        />)}

                                    </FlyToBounds>
                                </LeafletStaticMap>
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <br />

                <div className="content">
                    <ChartBarLine
                        titleGraph={"Taxa de lotação instantânea e kg de suplemento fornecido por dia"}
                        dataColumn={lotInstConsumo?.data1 || []}
                        dataLine={lotInstConsumo?.data2 || []}
                        colorIcons={["Kg de suplemento fornecido", "Média de Tx lotação instantânea"]}
                        axisLabels={["", "Kg de suplemento", "Tx lotação instantânea"]}
                        fullWidth
                    />
                    {typeManagement && typeManagement.map(((type: IOptionProps) => type.value)).includes("2") ? <>
                        <div className="noBreakComponent">
                            <div className="infoContentGraph">
                                <h2>Número de dias no intervalo: {snapshotMicroAreaMetrics?.daily_metrics.length}</h2>
                                <h2>Número de coleta de altura: {snapshotMicroAreaMetrics?.total_monitoring_counts.height_count} coletas</h2>
                                <h2>Média de dias de ocupação: {Number(snapshotMicroAreaMetrics?.total_occupation_days.average_occupied_days).toFixed(1)}</h2>
                                <h2>Média de dias de descanso: {Number(snapshotMicroAreaMetrics?.total_occupation_days.average_rest_days).toFixed(1)}</h2>
                            </div>
                            <ChartBarLine
                                titleGraph={"Taxa de lotação instatânea e altura de pasto em manejo contínuo"}
                                dataColumn={lotInstAltura?.data1 || []}
                                dataLine={lotInstAltura?.data2 || []}
                                colorIcons={["Média de Monitoramento", "Média de Tx lotação instantânea"]}
                                axisLabels={["", "Altura", "Tx lotação instantânea"]}
                                fullWidth
                            />
                        </div>
                        <div className="noBreakComponent">
                            <div className="infoContentGraph">
                                <h2>Número de dias no intervalo: {snapshotMicroAreaMetrics?.daily_metrics.length}</h2>
                                <h2>Número de coleta de nota: {snapshotMicroAreaMetrics?.total_monitoring_counts.rating_count} coletas</h2>
                                <h2>Média de dias de ocupação: {Number(snapshotMicroAreaMetrics?.total_occupation_days.average_occupied_days).toFixed(1)}</h2>
                                <h2>Média de dias de descanso: {Number(snapshotMicroAreaMetrics?.total_occupation_days.average_rest_days).toFixed(1)}</h2>
                            </div>

                            <ChartBarLine
                                titleGraph={"Taxa de lotação instatânea e nota de pasto em manejo contínuo"}
                                dataColumn={lotInstNota?.data1 || []}
                                dataLine={lotInstNota?.data2 || []}
                                colorIcons={["Média de Monitoramento", "Média de Tx lotação instantânea"]}
                                axisLabels={["", "Nota", "Tx lotação instantânea"]}
                                fullWidth
                            />
                        </div>
                    </> : <></>
                    }
                    {typeManagement && typeManagement.map(((type: IOptionProps) => type.value)).includes("3") ? <>
                        <div className="noBreakComponent">
                            <div className="infoContentGraph">
                                <h2>Média de dias de ocupação: {Number(snapshotMicroAreaMetrics?.total_occupation_days.average_occupied_days).toFixed(1)}</h2>
                                <h2>Média de dias de descanso: {Number(snapshotMicroAreaMetrics?.total_occupation_days.average_rest_days).toFixed(1)}</h2>
                            </div>
                            <ChartBar
                                titleGraph={"Taxa de lotação instantânea em manejo rotacionado"}
                                data={lotInst}
                                axisLabels={["", "Tx lotação instantânea"]}
                                colorIcons={"Média de Tx lotação instantânea"}
                                fullWidth
                            />
                        </div>
                        <div className="noBreakComponent">
                            <div className="infoContentGraph">
                                <h2>Número de dias no intervalo: {snapshotMicroAreaMetrics?.daily_metrics.length}</h2>
                                <h2>Número de coleta de altura: {snapshotMicroAreaMetrics?.total_monitoring_counts.height_count} coletas</h2>
                                <h2>Média de dias de ocupação: {Number(snapshotMicroAreaMetrics?.total_occupation_days.average_occupied_days).toFixed(1)}</h2>
                                <h2>Média de dias de descanso: {Number(snapshotMicroAreaMetrics?.total_occupation_days.average_rest_days).toFixed(1)}</h2>
                            </div>
                            <ChartBarLine
                                titleGraph={"Taxa de lotação instatânea e altura de pasto em manejo rotacionado"}
                                dataColumn={lotInstAltura?.data1 || []}
                                dataLine={lotInstAltura?.data2 || []}
                                colorIcons={["Média de Monitoramento", "Média de Tx lotação instantânea"]}
                                axisLabels={["", "Altura", "Tx lotação instantânea"]}
                                fullWidth
                            />
                        </div>
                        <div className="noBreakComponent">
                            <div className="infoContentGraph">
                                <h2>Número de dias no intervalo: {snapshotMicroAreaMetrics?.daily_metrics.length}</h2>
                                <h2>Número de coleta de nota: {snapshotMicroAreaMetrics?.total_monitoring_counts.rating_count} coletas</h2>
                                <h2>Média de dias de ocupação: {Number(snapshotMicroAreaMetrics?.total_occupation_days.average_occupied_days).toFixed(1)}</h2>
                                <h2>Média de dias de descanso: {Number(snapshotMicroAreaMetrics?.total_occupation_days.average_rest_days).toFixed(1)}</h2>
                            </div>
                            <ChartBarLine
                                titleGraph={"Taxa de lotação instatânea e nota de pasto em manejo rotacionado"}
                                dataColumn={lotInstNota?.data1 || []}
                                dataLine={lotInstNota?.data2 || []}
                                colorIcons={["Média de Monitoramento", "Média de Tx lotação instantânea"]}
                                axisLabels={["", "Nota", "Tx lotação instantânea"]}
                                fullWidth
                            />
                        </div>
                    </> : <></>
                    }
                    {typeManagement && typeManagement.map(((type: IOptionProps) => type.value)).includes("4") ? <>
                        <ChartBarLine
                            titleGraph={"Taxa de lotação instatânea e número de mudanças de faixa diárias"}
                            dataColumn={mockLotacaoPasto.faixa.bar}
                            dataLine={mockLotacaoPasto.faixa.line}
                            colorIcons={["Número de mudanças de faixa por dia", "Tx lotação instantânea"]}
                            axisLabels={["", "N° de faixa", "Tx lotação instantânea"]}
                            fullWidth
                        />
                    </> : <></>
                    }
                </div>
            </form >
        </div >
    );
}
